import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Route } from '@constants/routes';
import { type StringOption } from '@models/Option';

interface NotificationListProps {
    notifications: StringOption[];
}

export function NotificationsList({
    notifications,
}: NotificationListProps): ReactNode {
    if (!notifications.length) {
        return <p>No notifications found</p>;
    }

    return (
        <ul>
            {notifications.map((notification) => (
                <li key={notification.value}>
                    <Link
                        to={`${Route.SecurityNotifications}?title=equals:${notification.label}`}
                    >
                        {notification.label}
                    </Link>
                </li>
            ))}
        </ul>
    );
}
